export default {"src":"/_next/static/media/line-mobile.f2b5a9e9.svg","height":1,"width":150,"blurWidth":0,"blurHeight":0};